// extracted by mini-css-extract-plugin
export default {"profileSpinner":"Profile_profileSpinner__Jmfy6"};